import { Mic2 } from 'lucide-react';

/**
 * Non-hideable Voice badge — attribution is mandatory (PRD §3.4).
 */
export function VoiceBadge({
  label = 'Voice',
  size = 'sm',
}: {
  label?: string;
  size?: 'sm' | 'md';
}) {
  const pad = size === 'md' ? 'px-2 py-0.5 text-xs' : 'px-1.5 py-0.5 text-[10px]';
  return (
    <span
      className={`inline-flex items-center gap-1  border border-electric-mustard-400/60 bg-electric-mustard-50 font-mono uppercase tracking-wider text-electric-mustard-800 ${pad}`}
      title="Voice — constituency context; never a vote"
    >
      <Mic2 className={size === 'md' ? 'h-3.5 w-3.5' : 'h-3 w-3'} aria-hidden />
      {label}
    </span>
  );
}
